import React from 'react'
import { connect } from 'react-redux'
import DispatchList from '../DispatchList'
import DispatchDetail from '../DispatchDetail'

import './index.css'

const DispatchView = (props) => (
    <div className="dispatch-container">
        <div>
            <DispatchList model={'dispatch'} />
        </div>
        {props.selected && <DispatchDetail model="dispatch" id={props.selected} />}
    </div>
)

const mapStateToProps = state => ({
    unauthorized: state.auth.unauthorized,
    fetching: state.dispatch.fetching,
    items: state.dispatch.items,
    selected: state.dispatch.selected
})


export default connect(mapStateToProps)(DispatchView)


// WEBPACK FOOTER //
// ./src/containers/DispatchView/index.js